/* VEYR · Emerald Maison — small helpers: fabric loupe on product galleries, gentle reveals */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- Fabric loupe: hover a product photo to feel the weave ---- */
  function loupe(box) {
    var img = box.querySelector('img'); if (!img || box._loupe) return;
    box._loupe = 1;
    var src = box.getAttribute('data-zoom') || img.currentSrc || img.src;
    var L = 210, Z = 2.4, lens = document.createElement('span');
    lens.className = 'em-loupe'; lens.setAttribute('aria-hidden', 'true');
    lens.innerHTML = '<i>Feel the cloth</i>';
    box.appendChild(lens);
    var hi = new Image(), ready = false; hi.onload = function () { ready = true; }; 
    function move(e) {
      var r = box.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      var nw = img.naturalWidth || 1, nh = img.naturalHeight || 1;
      var s = Math.max(r.width / nw, r.height / nh), rw = nw * s, rh = nh * s, ox = (r.width - rw) / 2, oy = (r.height - rh) / 2;
      lens.style.transform = 'translate(' + (x - L / 2) + 'px,' + (y - L / 2) + 'px)';
      lens.style.backgroundImage = 'url("' + (ready ? hi.src : (img.currentSrc || img.src)) + '")';
      lens.style.backgroundSize = (rw * Z) + 'px ' + (rh * Z) + 'px';
      lens.style.backgroundPosition = (-((x - ox) * Z - L / 2)) + 'px ' + (-((y - oy) * Z - L / 2)) + 'px';
    }
    box.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; if (!hi.src) hi.src = src; box.classList.add('em-loupe-on'); move(e); });
    box.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e); });
    box.addEventListener('pointerleave', function () { box.classList.remove('em-loupe-on'); });
  }
  function initLoupes() { if (!fine) return; document.querySelectorAll('.template-product .gallery .zoomable').forEach(loupe); }

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('[data-em-reveal]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: .18 });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() { initLoupes(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
